import { render, staticRenderFns } from "./DropFile.vue?vue&type=template&id=be746aac&scoped=true"
import script from "./DropFile.vue?vue&type=script&lang=js"
export * from "./DropFile.vue?vue&type=script&lang=js"
import style0 from "./DropFile.vue?vue&type=style&index=0&id=be746aac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be746aac",
  null
  
)

export default component.exports